﻿import $ from "jquery";
import * as FormHelper from "../utils/formHelper"

var SearchNewsletterForm = function(email, linkToRedirect) {
    this.email = email;
    this.linkToRedirect = linkToRedirect;
};


let markEmailFieldAsError = () => {
    $("#notFoundError").show();
};

let search = function(form) {

    const linkToRedirect = form.linkToRedirect;
    const email = form.email;

    $.ajax({
        type: "GET",
        url: "/api/NewsletterApi/ContactExists",
        data: {
            email: form.email
        },

        success: function(contactExists) {
            if (contactExists) {
                window.location.href = `${linkToRedirect}?email=${email}`;
            } else {
                $("#notFoundError").show();
            }
        },

        error: markEmailFieldAsError
    });
};

let getSearchNewsletterForm = (searchNewsletterSection) => {
    if (!searchNewsletterSection.length) {
        return null;
    }

    var linkToRedirect = $(searchNewsletterSection).find(".submit-button").attr("href");
    var email = FormHelper.GetValuesArray(searchNewsletterSection, "input")[0];
    return new SearchNewsletterForm(email, linkToRedirect);
};

$(".js--newsletter-search-section").on("click",
    ".submit-button",
    function(e) {
        e.preventDefault();
        const section = $(this).closest(".js--newsletter-search-section");
        const form = getSearchNewsletterForm(section);
        if (form !== null && typeof form !== "undefined") {
            search(form);
        }
    });


//////////////////
// WEBPACK FOOTER
// ./Scripts/newsletter/newsletterSearchEmail.js
// module id = 11
// module chunks = 1